import CommonIFrame from '../atoms/CommonIFrame';

const DriversOfProfitGrowth = () => {
    return (
        <CommonIFrame
            src="https://dbnmfkjk454t4fdjskhji4bjkbjfkdbsjfknpsdsdgfsi.lovable.app"
            title="PVM Analysis"
        />
    );
};

export default DriversOfProfitGrowth;
